export const IMAGE_LOGO = {
    en: require('./logo/logo-en.png'),
    el: require('./logo/logo-el.png')
}

export const IMAGE_ICON= {
    en: require('./logo/logoIcon.png'),
    el: require('./logo/logoIcon.png')
}

